import * as React from 'react';
import AssetsManager from '../utils/AssetsManager';

const Assistant = ({assistantInformation, onPress, modal = false}) => {
    const assistant = assistantInformation.assistantMxes[0];
    const renderAssistant =
        <React.Fragment>
            <div className="budge-assistant">
                <img className="img-fluid" alt="alerta"
                     src={AssetsManager(
                         '/assets/images/common/assistant-badge.svg'
                     )}/>
            </div>
            <img src={assistant.assistantUrl} alt={assistant.assistantNameText}
                 className="img-fluid"/>
        </React.Fragment>;
    return <div className="wrapper-assistant">
        {!modal && <div className="content-assistant mb-4">
            <h4>{assistantInformation.title}</h4>
            <span dangerouslySetInnerHTML={{__html: assistantInformation.descriptionHtml}}/>
        </div>}
        <div className="assistant d-flex align-items-center">
            {modal ?
                <div className="img-assistant"
                          onClick={() => onPress(assistantInformation)}>
                    {renderAssistant}
                </div>
                :
                <div className="img-assistant">
                    {renderAssistant}
                </div>
            }
            {!modal && <div className="details-assistant">
                <h5>{assistant.assistantNameText}</h5>
                <p>{assistant.assistantChargeText}</p>
            </div>}
        </div>
    </div>;
};

export default Assistant;
